import { useFormik } from 'formik';
import { useEffect } from 'react';
import {
    CasesGeneral,
    CasesGenerallCallInfo,
} from '../../../../../../shared/types/modules/cases-general';
import { ISelect } from '../../../../../../shared/types/shared';

export const useCasesGeneralValidate = (casesGeneral?: CasesGeneral) => {
    const formik = useFormik({
        initialValues: {
            policie: '',
            plate: '',
            branch: '' as string | ISelect,
            document: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { callInfo = {} as CasesGenerallCallInfo, account } =
            casesGeneral || {};

        formik.setValues({
            policie: callInfo.policie || '',
            plate: callInfo.plate || '',
            branch: callInfo.branch || '',
            document: account?.document || '',
        });
    }, [casesGeneral]);

    const getBranchName = () =>
        typeof formik.values.branch === 'object'
            ? (formik.values.branch as ISelect)?.name || ''
            : formik.values.branch;

    return {
        formik,
        getBranchName,
        document,
    };
};
